// ============= Ask Relay Hub Events =============

/**
 * Enumerates all Ask relay hub events that the client can handle.
 * These events are raised by the server to communicate Ask session lifecycle
 * and message-related updates (documents, intents, tokens, etc.).
 */
export enum AskRelayHubEvents {
  /** Fired when a new message is received in an Ask session. */
  ASK_SESSION_MESSAGE_RECIEVED = 'ASK_SESSION_MESSAGE_RECIEVED',

  /** Fired when the AI/model has finished responding to a given message. */
  ASK_SESSION_MESSAGE_COMPLETION = 'ASK_SESSION_MESSAGE_COMPLETION',

  /** Fired when documents relevant to a message have been retrieved or updated. */
  ASK_SESSION_MESSAGE_DOCUMENTS = 'ASK_SESSION_MESSAGE_DOCUMENTS',

  /** Fired when detailed context (snippets, citations, etc.) for a message's documents has been provided. */
  ASK_SESSION_MESSAGE_DOCUMENT_CONTEXT = 'ASK_SESSION_MESSAGE_DOCUMENT_CONTEXT',

  /** Fired when audience/target information for a message is available. */
  ASK_SESSION_MESSAGE_AUDIENCE = 'ASK_SESSION_MESSAGE_AUDIENCE',

  /** Fired when external integrations or data sources attach additional payload to a message. */
  ASK_SESSION_MESSAGE_EXTERNAL = 'ASK_SESSION_MESSAGE_EXTERNAL',

  /** Fired when token counts or token-usage details are produced for a message. */
  ASK_SESSION_MESSAGE_TOKENS = 'ASK_SESSION_MESSAGE_TOKENS',

  /** Fired when the system has inferred the intent or type of a message. */
  ASK_SESSION_MESSAGE_INTENT = 'ASK_SESSION_MESSAGE_INTENT',

  /** Fired when a synopsis/summary of the current Ask session thread is produced. */
  ASK_SESSION_THREAD_SYNOPSIS = 'ASK_SESSION_THREAD_SYNOPSIS',

  /** Fired for partial/streaming chunks of a message response as they arrive. */
  ASK_SESSION_MESSAGE_STREAM = 'ASK_SESSION_MESSAGE_STREAM',

  /** Fired when a message stream starts. */
  ASK_SESSION_MESSAGE_STREAM_STARTED = 'ASK_SESSION_MESSAGE_STREAM_STARTED',

  /** Fired when a message stream ends. */
  ASK_SESSION_MESSAGE_STREAM_ENDED = 'ASK_SESSION_MESSAGE_STREAM_ENDED',

  /** Fired when a user is connected to the ask session. */
  USER_CONNECTED_TO_ASK_SESSION = 'USER_CONNECTED_TO_ASK_SESSION',
}
